/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const Gender = {
    Male: 'Male',
    Female: 'Female',
    Other: 'Other'
} as const;
export type Gender = typeof Gender[keyof typeof Gender];


export function instanceOfGender(value: any): boolean {
    for (const key in Gender) {
        if (Object.prototype.hasOwnProperty.call(Gender, key)) {
            if (Gender[key as keyof typeof Gender] === value) {
                return true;
            }
        }
    }
    return false;
}

export function GenderFromJSON(json: any): Gender {
    return GenderFromJSONTyped(json, false);
}

export function GenderFromJSONTyped(json: any, ignoreDiscriminator: boolean): Gender {
    return json as Gender;
}

export function GenderToJSON(value?: Gender | null): any {
    return value as any;
}

export function GenderToJSONTyped(value: any, ignoreDiscriminator: boolean): Gender {
    return value as Gender;
}

